
export class OutsourcingRequestVendorResponseModel {
    count:number
    next:string
    previous:string
    results: OutsourcingRequestVendorModel[]
}

export class OutsourcingRequestVendorModel {
    id:number
    access_token: string
    vendor_response_status: 'PENDING' | 'VIEWED' | 'DRAFTING' | 'SUBMITTED' | 'DECLINED'
    submitted_at: Date
    is_shortlisted: boolean
    is_finalized: boolean
    created_by: number
    modified_by: number
    quotation_request: number
    vendor: number
    vendor_details?: any
    quotation_request_details?: any
    quotation_request_vendor_id: string
    created_at: Date
    modified_at: Date
    created_by_name: string

}


export class VendorResponseModel {
    count: number
    next: string
    previous: string
    results: VendorModel[]
}

export class VendorModel {
    id: number
    name: string
    thumbnail: string
    email: string
    website:string
    contact_person: string
    phone_number: string
    notes: string
    categories_serviced: string[]
    location: string
    address_1:string
    address_2:string
    created_by: number
    modified_by: number
    city: number
    state:number
    country:number
    city_details:any[]
    country_code:number
    country_code_details:countryCodeDetails
    poc_details:PocDetails[]

}

export class PocDetails{
contact_person:string
country_code:number
country_code_details:countryCodeDetails
created_at:string
created_by:number
created_by_name:number
id:number
modified_at:string
modified_by:number
modified_by_name:string
phone_number:number
vendor:number

}


export class countryCodeDetails{
    id: number
    country_name: string
    code: string
    country: number
}


export class City {
    id:number
    name:string
    state:number
}
export class State {
    id:number
    name:string
    country:number
}
export class Country {
    id:number
    name:string
    slug:string
}

export class CountryResponseModel {
    count:number
    next:string
    previous:string
    results: Country[]
    initialValue?:any
}
export class StateResponseModel {
    count:number
    next:string
    previous:string
    results:  State[]
    initialValue?:any
}
export class CityResponseModel {
    count:number
    next:string
    previous:string
    results: City[]
    initialValue?:any
}

export class UserDetailModel {
    email: string
    name: string
    group_permission: []
    id: number
    image: string
    job_title: string
    permission: []
    roles: string
    type: any
    is_sales_person: boolean
    group:number[] = [];
    group_list: { id: number; name: string }[] = [];
    user_group: { id: number; name: string }[] = [];
}

export class UserResponseModel {
    count: number
    next: string
    previous: string
    results: UserDetailModel[]
}

export class VendorSubmissionResponseModel {
    count:number
    next:string
    previous:string
    results: OutsourcingRequestVendorModel[]
}

export class VendorSubmissionModel {
    created_at: string
    created_by: number
    created_by_name: string
    id: number
    last_saved_at: string
    modified_at: string
    modified_by: number
    modified_by_name: string
    overall_submission_notes: string
    quotation_request_vendor: string
    quotation_request_vendor_details: any
    submitted_at: string
    section_details:any
    amount_before_tax:string
    currency:number
    currency_type:string
    currency_type_details:any
    exchange_rate:string
    file:[]
    file_details:any
    product_details:any[]
    tax:[]
    total_price:string
    usd_amount:string
    time_zone:string
    time_zone_details:any
}


export class VendorProductModal{
    id:number
    product:string
    amount_before_tax:number
    total_price:number
    created_by:number
    modified_by:number
    submission:number
    tax:number[]
}

export class VendorSubmissionAnswerReponseModel {
    count:number
    next:string
    previous:string
    results: VendorSubmissionAnswerModel[]
}


export class VendorSubmissionAnswerModel {
    id: number
    answer_text_short: string
    answer_text_long: string
    answer_number: string
    answer_boolean: boolean
    answer_date: string
    answer_selected_choice_ids: string[]
    answer_file_references: string[]
    vendor_comment_on_answer: string
    submission: number
    question: number
    question_details: any
    submission_details: any
    created_at: string
    modified_at: string
    created_by: number
    modified_by: number
}

export class taxTypeResponseModal {
    count: number
    next: string
    previous: string
    results: taxTypeModal[]
}

export class taxTypeModal {
    id: number
    name: string
    slug: string
}

export class vendorTypeRespModal {
    count: number
    next: string
    previous: string
    results: vendorTypeModal[]
}

export class vendorTypeModal {
    id: number
    name: string
    slug: string
}

export class VendorFinancialStatsResponseModel {
    vendors: VendorFinancialStat[]
    event_budget: number | null
}

export class VendorFinancialStat {
    id: number
    name: string
    quotation_amount_usd: number
    invoice_amount_usd: number
    payment_amount_usd: number
}
